
import { MapTo } from '@adobe/aem-react-editable-components';
import NewsPressHero, { NewsPressHeroEditConfig } from './NewsPressHero';

export default MapTo('cob-corp-acquisition/components/creditonebank/news-press-hero')(NewsPressHero, NewsPressHeroEditConfig);
        